var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('navbar'),_c('banner'),_c('introduction'),_c('mission'),_c('about'),_c('partners'),_c('google-maps'),_c('conclusion')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }